import { MutationType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../base/base-mutation';
import { SLIDE_PAGE_DATA_TYPES } from '../../data';
import { checkRemoveAnimationData } from './animation-check-utils';
import type { MaybeError } from '../base/base-mutation';
import type { IValidAddAnimationMutationData, IValidRemoveAnimationMutationData } from '../base/valid-mutation-data';
import type { PresentationDataModel } from '../../model/presentation-data-model';

export class RemoveAnimationMutation extends BaseMutation<PresentationDataModel, IValidRemoveAnimationMutationData> {
    public readonly type: MutationType = MutationType.RemoveAnimation;

    public apply(presentation: PresentationDataModel) {
        if (!this.data.pageId) return;
        const { pageId, triggerId, index } = this.data;
        const page = presentation.store.models.get(pageId, ...SLIDE_PAGE_DATA_TYPES);
        page?.store.timing?.store.removeAnimation(triggerId, index);
    }

    public invert(): [IValidAddAnimationMutationData] {
        const { pageId, shapeId, triggerId, index, seqType } = this.data;
        return [
            {
                type: MutationType.AddAnimation,
                pageId,
                shapeId,
                triggerId,
                seqType,
                index,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId, triggerId, index, seqType } = this.data;
        const error = checkRemoveAnimationData(presentation, seqType, triggerId, shapeId, pageId, index);
        if (error) return error;
    }
}
